import React from 'react';
import { OptionRow } from './VoucherMetadata.styles';

export type VoucherMetadataProps = {
  voucherOption?: {
    name: string | null;
  };
};

export const VoucherMetadata: React.FC<VoucherMetadataProps> = ({ voucherOption }) => (
  <>{voucherOption && <OptionRow>{voucherOption.name}</OptionRow>}</>
);
